import {FieldValues} from "react-hook-form/dist/types/fields";
import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {Path, useFormContext} from "react-hook-form";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {ComboButton} from "@components/ComboButton";
import {IconPlayerPlayFilled, IconPlayerTrackNextFilled, IconPlayerTrackPrevFilled} from "@tabler/icons-react";
import ComboBoxLavoratori from "@components/comboBox/ComboBoxLavoratori";

interface SelectLavoratoreProps<T extends FieldValues> extends Pick<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'className'> {
    lavoratori: LavoratorePresenzeRecord[] | null,
    name: Path<T>,
    setValueCombo?: any,
    disableMonth?: boolean,
    onChange?: (lavoratore: any) => void,
    prev?: () => void,
    next?: () => void,
    reload?: () => void,
    hasApply?: boolean
}

export function SelectLavoratore<T extends FieldValues>(props: SelectLavoratoreProps<T>) {

    const {
        name,
        lavoratori,
        className,
        onChange,
        prev,
        next,
        hasApply,
    } = props;

    const formContext = useFormContext<T>()
    if (!formContext)
        throw new Error('Non hai specificato <FormProvider>!');
    const {register, control, watch} = formContext;
    const idLavoratore = watch(name);
    return (
        <div className="flex flex-row w-full">
            <div className={`flex flex-row ${className}`}>
                <div className="w-full px-2">

                    {/*<Select<T> label="Elenco lavoratori" id={name} name={name} onChange={onChange}
                               divClass="grow px-2" register={register} registerOptions={registerOptions}>

                        {lavoratori && lavoratori.map((item, index) => (
                            <option key={item.id} value={item.id} className="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9">
                                {item.cognome} {item.nome} [#{item.id}]
                            </option>))}

                    </Select>*/}

                    <ComboBoxLavoratori<T> data={lavoratori} control={control} name={name} defaultValue={null} label="Elenco lavoratori" onChange={onChange}/>
                </div>
            </div>

            {(prev || next || hasApply) && <div className={` flex flex-row grow items-end`}>
                {prev && <div className="">
                    <ComboButton onClick={prev} Icon={IconPlayerTrackPrevFilled}/>
                </div>}
                {next && <div className="">
                    <ComboButton onClick={next} Icon={IconPlayerTrackNextFilled}/>
                </div>}
                {hasApply && <div className="ml-auto ">
                    <ComboButton disabled={idLavoratore === 0} type='submit' Icon={IconPlayerPlayFilled}>Applica</ComboButton>
                </div>}
            </div>
            }
        </div>
    )
}
